import { createHtmlRenderState as t } from "./atoms-v21264.js";
const r = () => ({
  ...t(),
  attrs: {}
});
export {
  r as createSvgRenderState
};
